<!-- class card-body — marker: по нему вложенные app-card получают отступ (см. card.component) -->
<div class="card-body px-5 py-2.5">
  <ng-content/>
</div>
